import { render, staticRenderFns } from "./DisplayProjectTags.vue?vue&type=template&id=35990036&scoped=true"
import script from "./DisplayProjectTags.vue?vue&type=script&lang=ts"
export * from "./DisplayProjectTags.vue?vue&type=script&lang=ts"
import style0 from "./DisplayProjectTags.vue?vue&type=style&index=0&id=35990036&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35990036",
  null
  
)

export default component.exports